export interface BackupStatus {
  code: BackupStatusCode,
  date: string;
}

export enum BackupStatusCode {
  SUCCESS,
  NOT_INITIAL,
  IN_PROGRESS,
  ERROR_UPLOAD_TO_FTP,
  ERROR_ARCHIVATION,
  ERROR
}

export enum BackupStatusLevel {
  ERROR,
  WARNING,
  SUCCESS
}

export const backupStatusMessages = {
  [BackupStatusCode.SUCCESS]: 'Копію успішно збережено',
  [BackupStatusCode.ERROR]: 'Помилка резервного копіювання',
  [BackupStatusCode.IN_PROGRESS]: 'Створення резервної копії...',
  [BackupStatusCode.NOT_INITIAL]: 'Резервне копіювання не відбувалось',
  [BackupStatusCode.ERROR_ARCHIVATION]: 'Відбулась помилка архувації',
  [BackupStatusCode.ERROR_UPLOAD_TO_FTP]: 'Відбулась помилка завантаження на FTP сервер'
};

export const backupStatusLevelMessages = {
  [BackupStatusCode.SUCCESS]: BackupStatusLevel.SUCCESS,
  [BackupStatusCode.ERROR]: BackupStatusLevel.ERROR,
  [BackupStatusCode.IN_PROGRESS]: BackupStatusLevel.SUCCESS,
  [BackupStatusCode.NOT_INITIAL]: BackupStatusLevel.WARNING,
  [BackupStatusCode.ERROR_ARCHIVATION]: BackupStatusLevel.ERROR,
  [BackupStatusCode.ERROR_UPLOAD_TO_FTP]: BackupStatusLevel.ERROR
};
